
import React from "react";

export interface LeadCaptureData {
  firstName: string;
  lastName: string;
  email: string;
  interestType?: string;
  backgroundType?: string;
}

export interface FormErrors {
  firstName?: string;
  email?: string;
}

export interface StepProps {
  onStepSelection: (value: string, stepType: 'interestType' | 'backgroundType') => void;
}

export interface StepThreeProps {
  leadData: LeadCaptureData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleContinue: () => void;
  isFormValid: () => boolean;
  errors: FormErrors;
  validateField: (name: string, value: string) => void;
}

export interface DialogContentProps {
  step: number;
  progress: number;
  onClose: () => void;
  leadData: LeadCaptureData;
  handleStepSelection: (value: string, stepType: 'interestType' | 'backgroundType') => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleContinue: () => void;
  isFormValid: () => boolean;
  errors: FormErrors;
  validateField: (name: string, value: string) => void;
}

export interface LeadCaptureDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export enum EmbedType {
  IFRAME = 'iframe',
  FLOATING_BUTTON = 'floating-button'
}

export interface EmbedCodeOptions {
  type: EmbedType;
  companyName?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  logoUrl?: string;
}
